import { http } from '@pendo/http';

export function fetchLayouts () {
    return http.get('/api/s/_SID_/layout').then((res) => res.data);
}

export function fetchOrganizationLayouts (orgId, subId) {
    return http.get(`/api/organization/${orgId}/resources/layout?subId=${subId}`).then((res) => res.data);
}

export function deleteLayout (id) {
    return http.delete(`/api/s/_SID_/layout/${id}`);
}

export function fetchLayoutCategories ({ items } = {}) {
    const params = items ? '?items=true' : '';

    return http.get(`/api/s/_SID_/category/layoutCategory${params}`);
}
